import moment from 'moment'
import theme from "../styles/_theme.json";
import { getLocaleDateString, getLocaleTimeString } from './dateFormatByLang'

const unconventionalLanguages = {
  'zh-cht': 'zh-ch',
  'zh-chs': 'zh-ch'
}

export const getDateAndTimeFormat = () => {
  const langCode =  unconventionalLanguages[navigator.language.toLowerCase()] || navigator.language
  const dateFormat = getLocaleDateString(langCode)
  const timeFormat = getLocaleTimeString(langCode)

  return {
    langCode,
    dateFormat,
    timeFormat
  }
}

export const getModesAndSettings = (options) => {
  const { custom: { datePickerParams, timePickerParams } } = options

  const showDate = !!datePickerParams
  const showTime = !!timePickerParams
  const showDateTime = showDate && showTime

  const minDate = datePickerParams && datePickerParams.dateMinValue
    ? moment(datePickerParams.dateMinValue).toDate()
    : new Date(1900, 1, 1)

  const maxDate = datePickerParams && datePickerParams.dateMaxValue
    ? moment(datePickerParams.dateMaxValue).toDate()
    : new Date(2041, 1, 1)

  const yearsLength = new Date(maxDate).getFullYear() - new Date(minDate).getFullYear()
  const screenSize = theme.sm.substring(0, theme.sm.length - 2)

  return { showDate, showTime, showDateTime, minDate, maxDate, yearsLength, screenSize }
}
